import { useMutation } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useCollectionShareMutation = () => {
  return useMutation({
    mutationFn: async (collectionId: string) => {
      const { id: shareKey } =
        await adminApiClient.getCollectionShareKey(collectionId);
      const shareUrl = `https://studio.klydoclock.com/public/collection/${shareKey}`;
      return shareUrl;
    },
  });
};

export default useCollectionShareMutation;
